import FJCommunityMySpace from './FJCommunityMySpace';
import useLocalStore from '../../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import { useMemo, useCallback } from 'react';
import { MY_SPACE_TAB_LIST } from '../../../../config/dataConfig/FJCommunityData';
import FJConstant from '../../../../constants/FJConstant';
const FJCommunityMySpaceContainer = props => {
    const { active } = props;
    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.community.userInfo);
    useLocalStore();
    const mySpaceTabType = useSelector(state => state.community.mySpaceTabType);
    const guestUserInfo = useSelector(state => state.community.guestUserInfo);
    const isLoadedPage = useSelector(state => state.community.isLoadedPage);
    const myCreationsPageScene = useSelector(state => state.community.myCreationsPageScene);

    const onMySpaceTabChange = useCallback(
        value => {
            if (mySpaceTabType === value) {
                return;
            }
            dispatch(FJActionCommunity.changeMySpaceTabTypeAction(value));
        },
        [dispatch, mySpaceTabType],
    );
    const tabList = useMemo(() => {
        return MY_SPACE_TAB_LIST.filter(item => {
            if (guestUserInfo.guestMode) {
                return item.type === FJConstant.SHARED_CREATIONS;
            }
            return true;
        });
    }, [guestUserInfo]);
    const _userInfo = useMemo(() => {
        if (guestUserInfo?.guestMode) {
            return {
                avatar: guestUserInfo.avatar,
                username: guestUserInfo.username,
                likeNum: guestUserInfo.likeNum,
            };
        }
        return {
            avatar: userInfo.avatar,
            username: userInfo.username,
            likeNum: userInfo.likeNum,
        };
    }, [userInfo, guestUserInfo]);
    const onTotalScroll = useCallback(() => {
        if (mySpaceTabType === FJConstant.MY_CREATIONS && myCreationsPageScene === FJConstant.DETAIL) {
            dispatch(FJActionCommunity.getMoreMyCreationsDetailListAction());
        } else if (mySpaceTabType === FJConstant.SHARED_CREATIONS) {
            dispatch(FJActionCommunity.getMoreSharedCreationsListAction());
        } else if (mySpaceTabType === FJConstant.LIKED_CREATIONS) {
            dispatch(FJActionCommunity.getMoreLikedCreationsListAction());
        }
    }, [dispatch, mySpaceTabType, myCreationsPageScene]);
    return (
        <FJCommunityMySpace
            active={active}
            userInfo={_userInfo}
            mySpaceTabType={mySpaceTabType}
            onMySpaceTabChange={onMySpaceTabChange}
            isLoadedPage={isLoadedPage}
            guestUserInfo={guestUserInfo}
            tabList={tabList}
            onTotalScroll={onTotalScroll}
            myCreationsPageScene={myCreationsPageScene}
        />
    );
};

FJCommunityMySpaceContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJCommunityMySpaceContainer;
